import React, {FunctionComponent, useEffect, useState} from "react";
import {Button, Grid} from "@mui/material";
import OfflineBoltOutlinedIcon from '@mui/icons-material/OfflineBoltOutlined';
import {ASectionTitle} from "@atiautomacao/ati-ui-library";
import {MenuItemStatus} from "../../../../Shared/Components/Layout/menu/types/MenuItemStatus";
import {useAppDispatch, useAppSelector} from "../../../../Config/Hooks";
import {RootState} from "../../../../Config/Store";
import {Equipment, getEntity, reset, TeleObjectType} from "../../Skid/EquipmentDetailsSkid/EquipmentDetailsSkidReducer";
import EquipmentBasicInfo from "../../../../Shared/Components/EquipmentBasicInfo";
import StringCurrentsSection from "./components/StringCurrentsSection/StringCurrentsSection";
import ActiveAlarms from "../ActiveAlarms/ActiveAlarms";
import East from "@mui/icons-material/East";
import {SystemRoutes} from "../../../../Utils/RouteUtils";
import {useNavigate} from "react-router-dom";

const InverterSimplePage: FunctionComponent<{ equipmentId: number, status: MenuItemStatus }> = ({equipmentId, status}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const loading = useAppSelector((state: RootState) => state.equipmentDetailsSkid.loading);
    const selectedPowerPlant = useAppSelector((state: RootState) => state.dashboard.selectedPowerPlant);
    const [entity, setEntity] = useState<TeleObjectType | null>(null);
    const [equipmentToShow, setEquipmentToShow] = useState<Equipment | undefined>(undefined);

    useEffect(() => {
        setEntity(null);
        dispatch(reset());
        if (!loading) {
            dispatch(getEntity(equipmentId))
                .then((response) => {
                    if (response?.payload?.data?.data) {
                        setEntity(response.payload.data.data);
                    } else {
                        setEntity(null);
                    }
                }).catch((error) => {
                    console.log(error);
                });
        }
    }, [equipmentId]);

    useEffect(() => {
        if (entity?.equipment) {
            setEquipmentToShow({
                name: entity.equipment.name,
                lastDateTime: entity.equipment.lastDateTime,
                status: "Mudar",
                equipmentClass: entity.equipment.equipmentClass?.name,
                skid: entity.equipment.skid,
                description: entity.equipment?.description,
                utrIpAddress: entity.equipment?.utrIpAddress,
                seriesNumber: entity.equipment?.seriesNumber,
                abbreviation: entity.equipment?.abbreviation
            });
        } else {
            setEquipmentToShow(undefined);
        }
    }, [entity]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} style={{paddingTop: 0}}>
                <ASectionTitle
                    styleContainer={{ padding: '0 0 8px 0' }}
                    styleContainerTitle={{ padding: '0px' }}
                    styleTitle={{ fontWeight: 700, fontSize: 18 }}
                    titleIcon={
                        <OfflineBoltOutlinedIcon
                            sx={{
                                marginRight: 1,
                                color: '#171717',
                                width: '29.11px',
                                height: '29.11px',
                                opacity: 1,
                            }}/>
                    }
                    titleLabel={
                        equipmentToShow?.name
                            ? equipmentToShow?.skid?.name
                                ? `${equipmentToShow.name} | ${equipmentToShow.skid.name}`
                                : equipmentToShow.name
                            : ""
                    }
                    contentChildrenStyle={{ alignItems: 'center' }}
                    contentChildren={
                        <Button
                            variant="text"
                            color="primary"
                            size="small"
                            startIcon={<East />}
                            onClick={() => {navigate(SystemRoutes.DASHBOARD_POWER_PLANT_INVERTER)}}
                            sx={{
                                textTransform: 'uppercase',
                                '&:hover': {
                                    backgroundColor: 'transparent'
                                },
                                display: 'flex',
                                justifyContent: 'right',
                            }}
                        >
                            Ver detalhes de desempenho
                        </Button>
                    }
                />
            </Grid>

            <Grid item xs={12}>
                <EquipmentBasicInfo equipment={equipmentToShow} status={status} title={"Informações Básicas"}/>
            </Grid>

            <Grid item xs={12}>
                <StringCurrentsSection equipmentId={equipmentId} />
            </Grid>

            {selectedPowerPlant?.id ? (
                <Grid item xs={12}>
                    <ActiveAlarms
                        powerPlantId={selectedPowerPlant.id}
                        equipmentId={equipmentId}
                        columnPreset="inverter-simple"
                    />
                </Grid>
            ) : null}
        </Grid>
    );
}
export default InverterSimplePage;
